var isNonBlank = function (value) { return !!value && value.trim().length > 0; };
/** True if this subfield slot holds something other than blank-or-its-own-default. */
var subfieldHasContent = function (value, defaultValue) {
    if (!value)
        return false;
    if (value.values && value.values.some(function (entry) { return isNonBlank(entry.value); })) {
        return true;
    }
    if (value.components && Object.values(value.components).some(isNonBlank)) {
        return true;
    }
    return isNonBlank(value.value) && value.value !== defaultValue;
};
/**
 * True if any instance of `fieldDef` in the given form state carries content.
 *
 * `instances` is what `watch('fields.<key>')` returns — `undefined` while the
 * form is still initialising, which reads as "no content" (the field is then
 * simply collapsed, and a later render reveals it).
 */
export function fieldInstancesHaveContent(fieldDef, instances) {
    if (!instances || instances.length === 0)
        return false;
    var contentBearing = fieldDef.subfields.filter(function (sf) { return !(sf.hidden && sf.defaultValue !== undefined); });
    if (contentBearing.length === 0)
        return false;
    return instances.some(function (instance) {
        return contentBearing.some(function (sf) { return subfieldHasContent(instance === null || instance === void 0 ? void 0 : instance[sf.code], sf.defaultValue); });
    });
}
